import { useMemo } from "react";

export const useEpochList = (parsedModels: any[]) => {
  return useMemo(() => {
    const uniqueIds = Array.from(new Set(parsedModels.map((m: any) => m.trainHistory_id).filter(Boolean))).sort(
      (a, b) => a - b,
    );

    const historyIndexMap = new Map(uniqueIds.map((id, index) => [id, index + 1]));

    return parsedModels
      .map((m: any) => {
        let overkillPercent = "-";

        if (m.info) {
          try {
            const parsedInfo = JSON.parse(m.info);
            overkillPercent = parsedInfo?.performance
              ? `${(parsedInfo.performance.overkill * 100).toFixed(2)}%`
              : (parsedInfo?.overkillPercent ?? "-");
          } catch {
            overkillPercent = "-";
          }
        }

        return {
          id: m.id,
          uuid: m.uuid,
          epoch: typeof m.epoch === "object" ? m.epoch.current : m.epoch,
          trainHistory_id: m.trainHistory_id,
          validHistory_id: m.validHistory_id,
          historyIndex: m.round ?? historyIndexMap.get(m.trainHistory_id)!,
          overkillPercent,
          created_at: m.created_at,
        };
      })
      .sort((a, b) => a.epoch - b.epoch);
  }, [parsedModels]);
};
